import React, { useEffect, useState } from "react";
import "./CustomDraggableCards.css";
import { IconEdit, IconTrash, DragHandleIcon } from "assets/SVGs/SVGs";
import { formatPhoneNumber } from "utility";

const CustomDraggableCards = ({
  initialItems,
  className,
  onEdit,
  onDelete,
  onDragEnd,
  emergencyData,
  showAddContactModal,
  onAddContact,
  titles,
}) => {
  const [items, setItems] = useState([]);
  const [draggedIndex, setDraggedIndex] = useState(null);

  useEffect(() => {
    setItems(initialItems);
  }, [initialItems]);

  const handleDragStart = (e, index) => {
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/html", e.currentTarget);
    setDraggedIndex(index);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    if (draggedIndex === null) return;

    const updatedList = [...items];
    const [draggedItem] = updatedList.splice(draggedIndex, 1);
    
    updatedList.splice(dropIndex, 0, draggedItem);
    
    setItems(updatedList);
    onDragEnd(updatedList);
    setDraggedIndex(null);
  };

  const renderPhoneList = () => {
    const updatedArrayForAddContact = items?.filter(
      (obj) => !obj.is_delete
    );
    
    return (
      <>
        {updatedArrayForAddContact?.map((contact, index) => (
          <div
            key={contact?.id || index}
            className="ep_phone_contact_item"
            data-drag-index={index}
            onDragStart={(e) => handleDragStart(e, index)}
            onDragOver={handleDragOver}
            draggable={true}
            onDrop={(e) => handleDrop(e, index)}
          >
            <DragHandleIcon className="ep_drag_handle" height="64" />
            <div className="ep_phone_info">
              <p className="ep_phone_number">
                {contact?.isDefaultPhone
                  ? `**EMERGENCY SERVICES**\nDEFAULT`
                  : `${contact?.name || ""}${contact?.relation ? ` & ${contact?.relation?.relation}` : ""}\n${formatPhoneNumber(contact?.phone || contact?.phoneNumber || "")}`}
              </p>
               {!contact?.isDefaultPhone && (
                <>
                  <IconEdit
                    className="ep_edit_icon"
                    color="#595252"
                    onClick={() => onEdit(contact)}
                  />
                  <IconTrash
                    className="ep_delete_icon"
                    color="#595252"
                    onClick={() => onDelete(contact)}
                  />
                </>
              )}
            </div>
          </div>
        ))}

        {(!emergencyData?.max_contact_limit ||
          emergencyData?.max_contact_limit >= updatedArrayForAddContact?.length) && 
          !showAddContactModal && (
          <button className="ep_add_contact_link" onClick={onAddContact}>
            {titles?.add_contact}
          </button>
        )}
      </>
    );
  };

  return (
    <div className={className}>
      {renderPhoneList()}
    </div>
  );
};

export default CustomDraggableCards;
